import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
// Support both ANON_KEY (standard) and PUBLISHABLE_KEY (legacy) for backwards compatibility
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY || import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

const EXPECTED_PROJECT_REF = 'eifaqgeoxexafklrrjlh';

// ── Runtime validation ──────────────────────────────────────────────
if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  console.error('[Supabase] FATAL: Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY');
  // Render blocking banner
  const banner = document.createElement('div');
  banner.id = 'supabase-env-error';
  banner.style.cssText =
    'position:fixed;inset:0;z-index:99999;display:flex;align-items:center;justify-content:center;' +
    'background:#0b1b2e;color:#fff;font-family:system-ui;padding:2rem;text-align:center';
  banner.innerHTML =
    '<div><h1 style="font-size:1.5rem;margin-bottom:.5rem">⚠️ Configuration Error</h1>' +
    '<p style="opacity:.7">Supabase environment variables are missing.<br/>Contact the admin.</p></div>';
  document.body.prepend(banner);
}

// In production, verify we're pointing at the correct project
if (
  SUPABASE_URL &&
  !import.meta.env.DEV &&
  !SUPABASE_URL.includes(EXPECTED_PROJECT_REF)
) {
  console.warn(
    `[Supabase] WARNING: URL does not contain expected project ref "${EXPECTED_PROJECT_REF}". ` +
    `Got: ${SUPABASE_URL}`
  );
}

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});

/** Derived helpers for diagnostics */
export const supabaseProjectRef = SUPABASE_URL
  ? SUPABASE_URL.split('//')[1]?.split('.')[0] ?? 'unknown'
  : 'missing';
export const supabaseAnonKeyPresent = !!SUPABASE_ANON_KEY;